// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"05b3afa0","455":"519e9f56"}[chunkId] + ".chunk.js";
};